import { Alert, AlertIcon, Box, Flex, FlexProps } from "@chakra-ui/react";
import { FC, ReactNode } from "react";

import { UploadTask } from "@nens/brostar/openapi-client";

import { BroErrorModal } from "@/components/bro-error-modal";
import { Link } from "@/components/link";

interface RenderWrapperProps extends FlexProps {
  children?: ReactNode;
}

const RenderWrapper: FC<RenderWrapperProps> = (props) => (
  <Flex {...props} h="full" alignItems="center">
    <Box textOverflow="ellipsis" overflow="hidden" whiteSpace="nowrap">
      {props.children}
    </Box>
  </Flex>
);

export const renderDefault = (
  render: string | number | object | Date | null | undefined,
  link?: string
) => {
  render = render instanceof Date ? render.toLocaleString() : render;
  return (
    <RenderWrapper>
      {link && (
        <Link inline to={link}>
          {render + ""}
        </Link>
      )}
      {!link && (render instanceof Object ? "object" : render)}
    </RenderWrapper>
  );
};

export const renderEnum = (
  render: string | number | null | undefined,
  enumOptions: { key: string | number; label: string }[]
) => {
  const enumLabel = enumOptions.find(({ key }) => key === render)?.label ?? render;
  return <RenderWrapper>{enumLabel}</RenderWrapper>;
};

export const renderStatus = ({ status }: UploadTask) => {
  const getAlertStatus = () => {
    switch (status) {
      case "PENDING":
      case "PROCESSING":
        return "loading";
      case "COMPLETED":
        return "success";
      default:
        return "error";
    }
  };

  return (
    <RenderWrapper>
      <Alert
        title={status}
        my="auto"
        status={getAlertStatus()}
        bg=""
        size="xs"
        p="0"
        pl="2"
        w="fit-content"
        h="fit-content"
      >
        <AlertIcon m="0" />
      </Alert>
    </RenderWrapper>
  );
};

export const renderReference = ({ metadata }: { metadata?: { requestReference?: string } }) => {
  return <RenderWrapper>{metadata?.requestReference ?? "onbekend"}</RenderWrapper>;
};

export const renderLog = (row: UploadTask) => {
  if (!row.broErrors) return <RenderWrapper>{row.log}</RenderWrapper>;
  return (
    <Flex pos="relative" h="full" alignItems="center">
      <RenderWrapper>{row.log}:</RenderWrapper>
      <Flex w="32px" pos="absolute" right={0} top="50%" transform="translateY(-50%)">
        <BroErrorModal uploadTask={row} />
      </Flex>
    </Flex>
  );
};
